export { d as delay, l as limit2 } from '../lib/limit2-B1aIcHAv.mjs';
import plimit__default from 'p-limit';
import '../lib/array-DNG3qZDq.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class LimitBuilder {
  constructor(data, max) {
    __publicField(this, "limiter");
    __publicField(this, "data");
    this.data = data;
    this.limiter = plimit__default(max);
  }
  run(process) {
    return Promise.all(this.data.map((d) => this.limiter(process, d)));
  }
}
function limit(data, max = 5) {
  return new LimitBuilder(data, max);
}

const withResolvers = () => {
  const res = [];
  res[0] = new Promise((resolve, reject) => {
    res[1] = resolve;
    res[2] = reject;
  });
  return res;
};
const isPromise = (value) => Promise.resolve(value) === value;

function aggregateRejections(results, message) {
  const failed = results.filter((res) => res.status === "rejected");
  if (failed.length > 0) {
    throw new AggregateError(
      failed.map((res) => res.reason),
      message
    );
  }
  return results.map((res) => res.value);
}
async function allEntries(obj) {
  const entries = await Promise.allSettled(
    Object.entries(obj).map(async ([key, value]) => {
      if (isPromise(value)) {
        return value.then((v) => [key, v]);
      }
      return [key, value];
    })
  );
  return Object.fromEntries(aggregateRejections(entries, "One or more entries failed"));
}

function asyncMutex(options) {
  const { timeout = 0 } = options || {};
  let theLock = Promise.resolve();
  let locks = 0;
  const lockHandler = (nextEnter) => {
    if (!nextEnter) {
      return res;
    }
    locks += 1;
    let unlock;
    let timer;
    const nextLock = new Promise((resolve) => {
      unlock = () => {
        locks -= 1;
        clearTimeout(timer);
        resolve();
      };
    });
    theLock.then(async () => {
      if (timeout > 0) {
        timer = setTimeout(unlock, timeout);
      }
      await nextEnter(unlock);
    }).catch(unlock);
    theLock = nextLock;
    return res;
  };
  const res = {
    get locked() {
      return locks > 0;
    },
    then: lockHandler,
    lock: lockHandler
  };
  return res;
}

export { LimitBuilder, aggregateRejections, allEntries, asyncMutex, isPromise, limit, withResolvers };
/*                              */
